import { defineStore } from 'pinia'

import { useBodyOverflowControl } from '~/composables/use-body-overflow-control'

export const messages = {
}

type State = {
  showMobileMenu: boolean
}

const initialState = (): State => ({
  showMobileMenu: false,
})

export const useMobileMenuStore = defineStore('mobileMenu', {
  state: () => initialState(),
  getters: {
    isShowMobileMenu: (state: State) => state.showMobileMenu,
  },
  actions: {
    closeMobileMenu (): void {
      const bodyOverflowControl = useBodyOverflowControl()

      this.showMobileMenu = false

      bodyOverflowControl.enable()
    },
    openMobileMenu (): void {
      const bodyOverflowControl = useBodyOverflowControl()

      this.showMobileMenu = true

      bodyOverflowControl.disable()
    },
    toggleMobileMenu (): void {
      if (this.showMobileMenu) {
        this.closeMobileMenu()
      } else {
        this.openMobileMenu()
      }
    }
  }
})
